/**
 * One container's live card (the mock's card grammar): chip · honest state
 * pill · sent/planned mono, then the strip of today's drops (20/10/2026)
 * and the body it shares with the row — groups, verdicts, held drops, Edit.
 * "Edit container" rides the ?container= drawer that mounts on any tab.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DayPlanContainerRow } from '../../drop-generator.types';
import { ContainerChip } from '../shared/ContainerChip';
import { ContainerDayBadge, type LiveAutoSend } from '../shared/StateBadges';
import { ContainerLiveBody, type ContainerLiveActions, type ContainerLiveReport } from './container/ContainerLiveBody';
import { deriveContainerLive } from './live-status';
import { DropStrip } from './strip/DropStrip';

export type { LiveAutoSend } from '../shared/StateBadges';

type Props = ContainerLiveActions & ContainerLiveReport & { container: DayPlanContainerRow; autoSend?: LiveAutoSend; now?: Date };

export const ContainerLiveCard: FC<Props> = ({ container, autoSend = null, now = new Date(), ...body }) => {
  const facts = deriveContainerLive(container);
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border/60 bg-card p-4">
      <div className="flex items-center gap-2">
        <ContainerChip name={container.name} color={container.color} />
        <ContainerDayBadge facts={facts} autoSend={autoSend} />
        <span className="grow" />
        {facts.state !== 'not-generated' && facts.state !== 'paused' ? (
          <span className="font-mono text-xs tabular-nums text-muted-foreground">
            {facts.sent}/{facts.planned}
            {facts.auto > 0 ? ` · ${facts.auto} auto` : ''}
          </span>
        ) : null}
      </div>
      <DropStrip drops={container.drops} now={now} />
      <ContainerLiveBody container={container} facts={facts} {...body} />
    </div>
  );
};
